export class StringUtils {

  static truncate(str, n){
    return (str.length > n) ? str.substr(0, n-1) : str;
  };

  static getAllAfterLastChar(input, char) {
    return input ? input.split(char).pop() : null;
  }

}